import React from "react";
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import SwitchOnKitSectionHeader from "./SwitchOnKitSectionHeader";

const SwitchOnKitOptions = ({ title, codes, rightSelected, leftSelected, linked, setLinked, getOptionsForSide, optionVisible, allowedValues, selectedOptions, setOption }) => {
  const renderSide = (side) => getOptionsForSide(side)
    .filter((option) => codes.includes(option.Code))
    .sort((a, b) => codes.indexOf(a.Code) - codes.indexOf(b.Code))
    .map((option) => optionVisible(option, side) && <div className="switch-on-kit-option ite-custom-options-div" key={`${side}-${option.Code}`}>
      <Row><Col md={6}><div className="select"><select value={selectedOptions[side][option.Name] || ""} onChange={(event) => setOption(side, option, event.target.value)}>
        <option value="">Please select</option>{allowedValues(option, side).map((value) => <option key={value} value={value}>{value}</option>)}
      </select></div></Col><Col md={6}><p>{option.Name}</p></Col></Row>
    </div>);

  return <div className="switch-on-kit-option-section">
    <SwitchOnKitSectionHeader title={title} rightSelected={rightSelected} leftSelected={leftSelected} linked={linked} setLinked={setLinked}>
      <Col md={6}><div className="ite-custom-options-row-right">{rightSelected && renderSide("R")}</div></Col>
      <Col md={6} className="left-side"><div className="ite-custom-options-row-left">{leftSelected && renderSide("L")}</div></Col>
    </SwitchOnKitSectionHeader>
  </div>;
};

SwitchOnKitOptions.propTypes = {
  title: PropTypes.string, codes: PropTypes.array, rightSelected: PropTypes.bool, leftSelected: PropTypes.bool,
  linked: PropTypes.bool, setLinked: PropTypes.func, getOptionsForSide: PropTypes.func,
  optionVisible: PropTypes.func, allowedValues: PropTypes.func, selectedOptions: PropTypes.object, setOption: PropTypes.func,
};
export default SwitchOnKitOptions;
